
define(['underscore', 'underscore.string', 'core', 'app-common/component/service-call'], function(_, _s, core, serviceCall) {
  var BookkeeperNotifications;
  return BookkeeperNotifications = (function() {

    function BookkeeperNotifications(transactionId) {
      this.transactionId = transactionId;
    }

    BookkeeperNotifications.prototype._isBookkeeper = function() {
      return core.isCurrentClientBookkeeper();
    };

    BookkeeperNotifications.prototype._getExtraParams = function() {
      if (this._isBookkeeper()) {
        return {
          group: 'BENCH'
        };
      } else {
        return {};
      }
    };

    BookkeeperNotifications.prototype.serializeBKTransactionEvents = function(events) {
      if (events == null) {
        events = this.bkEvents;
      }
      return this.bkEvents = events.map(function(event) {
        event.assets = _.indexBy(event.assets, function(asset) {
          return asset.payloadName || asset[asset.assetType];
        });
        return event;
      });
    };

    BookkeeperNotifications.prototype.getEvents = function(userId, resourceIds, names) {
      var accountantId, params;
      if (resourceIds == null) {
        resourceIds = [];
      }
      if (names == null) {
        names = ['feed.comment.transaction'];
      }
      if (!this._isBookkeeper()) {
        return null;
      }
      accountantId = core.getCurrentUserid();
      params = $.param({
        fetchFlags: false,
        fetchStats: false,
        cids: [userId],
        full: true,
        group: 'BENCH',
        names: names,
        resourceIds: resourceIds.join(',')
      });
      return serviceCall('nodeway', "notifications/bk/" + accountantId + "?&" + params);
    };

    BookkeeperNotifications.prototype.removeEvents = function(transactionId, eventName) {
      var params;
      if (transactionId == null) {
        transactionId = this.transactionId;
      }
      if (eventName == null) {
        eventName = 'feed.comment.transaction';
      }
      params = $.param(this._getExtraParams());
      return serviceCall('nodeway', "notifications/" + (core.getCurrentUserid()) + "/resources/" + transactionId + "/" + eventName + "?" + params, 'DELETE');
    };

    return BookkeeperNotifications;

  })();
});
